var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArcade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,0H6C5.4,0,5,0.4,5,1v5c0,0.1,0,0.2,0,0.3l2.9,9.6l-1.8,3.6c0,0,0,0,0,0c0,0,0,0,0,0.1C6,19.8,6,19.9,6,20c0,0,0,0,0,0 v11c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V20c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.3c0,0,0,0,0-0.1c0,0,0,0,0,0l-1.8-3.6L27,6.3 c0-0.1,0-0.2,0-0.3V1C27,0.4,26.6,0,26,0z M14,17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1c0-0.6,0.4-1,1-1s1,0.4,1,1V17z M17.9,17.4 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.3,18,17.1,18,17,18c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2 c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4C18,17.1,18,17.3,17.9,17.4z M19.3,17.7C19.1,17.5,19,17.3,19,17c0-0.3,0.1-0.5,0.3-0.7c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2 c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7c-0.1,0.1-0.2,0.2-0.3,0.2C20.3,18,20.1,18,20,18c-0.1,0-0.3,0-0.4-0.1 C19.5,17.9,19.4,17.8,19.3,17.7z M22,26c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-0.6,0.4-1,1-1s1,0.4,1,1V26z M22,15h-8v-1.3 c0.6-0.3,1-1,1-1.7c0-1.1-0.9-2-2-2s-2,0.9-2,2c0,0.7,0.4,1.4,1,1.7V15h-2V7h12V15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArcade);
export default __webpack_public_path__ + "static/media/icon-arcade.a968dab84cdd75b1183e4ee07adc6711.svg";
export { ForwardRef as ReactComponent };